import React from "react";

const AnalystBotIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 3.125C4.25 3.61483 3.93695 4.03155 3.5 4.18599V9.5L5.12056 13.615L3.5 17.75C2.675 17.75 2 17.0756 2 16.2514V10.9986C2 10.4469 2.3025 9.96222 2.75 9.70212V4.18599C2.31305 4.03155 2 3.61483 2 3.125C2 2.50368 2.50368 2 3.125 2C3.74632 2 4.25 2.50368 4.25 3.125Z"
        fill="#F8312F"
      />
      <path
        d="M23.0377 3.1625C23.0377 3.6733 22.7083 4.10716 22.2503 4.26318V9.64985C22.6978 9.91017 23.0003 10.3953 23.0003 10.9476V16.2051C23.0003 17.0301 22.3253 17.7051 21.5003 17.7051L19.2949 13.4457L21.5003 9.44757V4.2632C21.0423 4.10721 20.7128 3.67333 20.7128 3.1625C20.7128 2.52047 21.2332 2 21.8753 2C22.5173 2 23.0377 2.52047 23.0377 3.1625Z"
        fill="#F8312F"
      />
      <path
        d="M8.75 3.875C8.75 3.25368 9.2537 2.75 9.875 2.75H15.125C15.7463 2.75 16.25 3.25368 16.25 3.875C16.25 4.38449 15.9113 4.81488 15.4468 4.9533C15.2394 5.01509 15.0196 5.03121 14.8122 5.09266L12.5224 5.77094L10.1831 5.08973C9.97872 5.03021 9.76258 5.01463 9.55828 4.9548C9.09118 4.81802 8.75 4.38635 8.75 3.875Z"
        fill="#FFB02E"
      />
      <path
        d="M17.0375 23H7.9625C5.495 23 3.5 21.005 3.5 18.5375V9.5225C3.5 7.025 5.525 5 8.0225 5H16.985C19.475 5 21.5 7.025 21.5 9.5225V18.545C21.5 21.005 19.505 23 17.0375 23Z"
        fill="#CDC4D6"
      />
      <path
        d="M7.43553 14.375H17.5644C19.3116 14.375 20.75 12.9358 20.75 11.1875C20.75 9.43175 19.3191 8 17.5644 8H7.43553C5.68085 8 4.25 9.43175 4.25 11.1875C4.25 12.9432 5.68085 14.375 7.43553 14.375Z"
        fill="#212121"
      />
      <path
        d="M10.6039 20H14.3961C15.0044 20 15.5 19.4949 15.5 18.875C15.5 18.2551 15.0044 17.75 14.3961 17.75H10.6039C9.9956 17.75 9.5 18.2551 9.5 18.875C9.5 19.4949 9.9956 20 10.6039 20Z"
        fill="#212121"
      />
      <path
        d="M8.1875 9.5C7.66973 9.5 7.25 9.9197 7.25 10.4375V12.3125C7.25 12.8303 7.66973 13.25 8.1875 13.25C8.7053 13.25 9.125 12.8303 9.125 12.3125V10.4375C9.125 9.9197 8.7053 9.5 8.1875 9.5Z"
        fill="#00A6ED"
      />
      <path
        d="M16.8125 9.5C16.2947 9.5 15.875 9.9197 15.875 10.4375V12.3125C15.875 12.8303 16.2947 13.25 16.8125 13.25C17.3303 13.25 17.75 12.8303 17.75 12.3125V10.4375C17.75 9.9197 17.3303 9.5 16.8125 9.5Z"
        fill="#00A6ED"
      />
    </svg>
  );
};

export default AnalystBotIcon;
